// 客户管理
import type { RouteRecordRaw } from 'vue-router'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/customer',
    name: 'Customer',
    component: defaultLayout,
    meta: {
      locale: 'common.menus.customer',
      requiresAuth: true,
      icon: 'customer',
      hideChildrenInMenu: true,
      activeMenu: 'Customer',
      order: 3,
    },
    children: [
      {
        path: '',
        name: 'CustomerIndex',
        component: () => import('@/views/customer/index.vue'), // 客户列表
        meta: {
          locale: 'common.menus.customer',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Customer',
          isTopMenu: true, // 是否是顶级菜单
        },
      },
      {
        path: 'detail',
        name: 'CustomerDetail',
        component: () => import('@/views/customer/detail.vue'), // 客户详情
        meta: {
          locale: 'common.menus.customerDetail',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Customer',
          isTopMenu: false,
        },
      },
      {
        path: 'order',
        name: 'CustomerOrder',
        component: () => import('@/views/order/index.vue'), // 客户详情
        meta: {
          locale: 'common.order',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Customer',
          isTopMenu: false,
        },
      },
    ],
  },
]

export default routes
